import React from 'react';
import { Link, withRouter } from 'react-router-dom';

const Redirect = ({ value, match }) => (value ? <Link to={match.path + '/' + value}>{value}</Link> : '-');

export default withRouter(Redirect);
